// English (source) - all UI strings in the app
const en: Record<string, string> = {
  "Overview": "Overview",
  "Loading...": "Loading...",
  "Failed to load dashboard.": "Failed to load dashboard.",
  "Something went wrong loading your dashboard.": "Something went wrong loading your dashboard.",
  "Try again": "Try again",
  "Add credits": "Add credits",
  "Total lookups": "Total lookups",
  "Credits remaining": "Credits remaining",
  "Active API keys": "Active API keys",
  "This week": "This week",
  "Active monitors": "Active monitors",
  "Emails tracked": "Emails tracked",
  "Changes this week": "Changes this week",
  "Recent changes": "Recent changes",
  "Latest job & company changes detected": "Latest job & company changes detected",
  "Lookups": "Lookups",
  "Last 7 days": "Last 7 days",
  "Credit usage": "Credit usage",
  "Daily credit consumption": "Daily credit consumption",
  "Monitor email changes": "Monitor email changes",
  "Track when email addresses become invalid, change providers, or get flagged as disposable.": "Track when email addresses become invalid, change providers, or get flagged as disposable.",
  "Create your first monitor": "Create your first monitor",
  "Monitor activity": "Monitor activity",
  "Changes detected per day": "Changes detected per day",
  "Changes detected": "Changes detected",
  "Email validity": "Email validity",
  "Breakdown of verified email addresses": "Breakdown of verified email addresses",
  "No lookup data yet. Run some lookups to see validity breakdown.": "No lookup data yet. Run some lookups to see validity breakdown.",
  "Email lookup": "Email lookup",
  "Search for a person by their email address.": "Search for a person by their email address.",
  "Enter email address...": "Enter email address...",
  "Searching...": "Searching...",
  "Lookup": "Lookup",
  "Select a detail to explore the response": "Select a detail to explore the response",
  "Example response": "Example response",
  "Illustrative schema and sample values": "Illustrative schema and sample values",
  "Bulk upload": "Bulk upload",
  "Upload a CSV or TXT file with email addresses to enrich in bulk. Up to 1,000 emails process in real-time; larger files up to 100,000 are queued.": "Upload a CSV or TXT file with email addresses to enrich in bulk. Up to 1,000 emails process in real-time; larger files up to 100,000 are queued.",
  "Clear": "Clear",
  "browse": "browse",
  "CSV, TXT - one email per line or comma-separated": "CSV, TXT - one email per line or comma-separated",
  "emails found": "emails found",
  "Queue job": "Queue job",
  "Enrich all": "Enrich all",
  "Cancel": "Cancel",
  "Processing": "Processing",
  "Complete": "Complete",
  "Failed": "Failed",
  "Cancelled": "Cancelled",
  "enriched": "enriched",
  "failed": "failed",
  "credits used": "credits used",
  "Download results": "Download results",
  "Processing in background - you can close this modal. Results will be emailed when complete.": "Processing in background - you can close this modal. Results will be emailed when complete.",
  "Download JSON": "Download JSON",
  "Download CSV": "Download CSV",
  "No results yet": "No results yet",
  "Enter an email address above to look up a person. Results will appear here.": "Enter an email address above to look up a person. Results will appear here.",
  "Export results": "Export results",
  "JSON": "JSON",
  "CSV": "CSV",
  "result": "result",
  "results": "results",
  "Lookup complete": "Lookup complete",
  "Lookup failed": "Lookup failed",
  "An unexpected error occurred": "An unexpected error occurred",
  "No valid emails found in file": "No valid emails found in file",
  "Name": "Name",
  "Email": "Email",
  "Validity": "Validity",
  "Checks whether this inbox can receive email, including disposable and catch-all addresses.": "Checks whether this inbox can receive email, including disposable and catch-all addresses.",
  "Finds the name, job title, company, and location linked to an email address.": "Finds the name, job title, company, and location linked to an email address.",
  "Shows whether an email address appeared in known data breaches and what was exposed.": "Shows whether an email address appeared in known data breaches and what was exposed.",
  "Estimates likely gender from the first name. This is a statistical estimate.": "Estimates likely gender from the first name. This is a statistical estimate.",
  "Summarizes email marketing rules for the likely recipient country. Not legal advice.": "Summarizes email marketing rules for the likely recipient country. Not legal advice.",
  "Job title": "Job title",
  "Company": "Company",
  "Industry": "Industry",
  "Location": "Location",
  "Company Lookup": "Company Lookup",
  "Search and discover detailed information about any company.": "Search and discover detailed information about any company.",
  "Enter company name...": "Enter company name...",
  "Search": "Search",
  "Company search complete": "Company search complete",
  "Search failed": "Search failed",
  "No valid queries found in file": "No valid queries found in file",
  "Address": "Address",
  "Employees": "Employees",
  "Founded": "Founded",
  "Website": "Website",
  "Revenue": "Revenue",
  "Funding": "Funding",
  "Title": "Title",
  "Source": "Source",
  "Snippet": "Snippet",
  "Link": "Link",
  "Domain Lookup": "Domain Lookup",
  "Look up WHOIS information and web presence for any domain.": "Look up WHOIS information and web presence for any domain.",
  "Enter domain (e.g. example.com)...": "Enter domain (e.g. example.com)...",
  "Domain lookup complete": "Domain lookup complete",
  "No valid domains found in file": "No valid domains found in file",
  "WHOIS Information": "WHOIS Information",
  "Domain": "Domain",
  "Registrar": "Registrar",
  "Created": "Created",
  "Updated": "Updated",
  "Expires": "Expires",
  "DNSSEC": "DNSSEC",
  "Organization": "Organization",
  "Country": "Country",
  "DNS Records": "DNS Records",
  "A (IPv4)": "A (IPv4)",
  "AAAA (IPv6)": "AAAA (IPv6)",
  "MX (Mail)": "MX (Mail)",
  "NS (Nameservers)": "NS (Nameservers)",
  "CNAME": "CNAME",
  "TXT": "TXT",
  "SOA": "SOA",
  "SSL/TLS Certificate": "SSL/TLS Certificate",
  "Valid": "Valid",
  "Protocol": "Protocol",
  "Issuer": "Issuer",
  "Subject": "Subject",
  "Valid from": "Valid from",
  "Days remaining": "Days remaining",
  "Key algorithm": "Key algorithm",
  "Security & Open Ports": "Security & Open Ports",
  "Phone Lookup": "Phone Lookup",
  "Validate and get details for any phone number worldwide.": "Validate and get details for any phone number worldwide.",
  "Enter phone number (e.g. +14155552671)...": "Enter phone number (e.g. +14155552671)...",
  "No valid phone numbers found in file": "No valid phone numbers found in file",
  "Phone number": "Phone number",
  "Invalid": "Invalid",
  "Format": "Format",
  "International": "International",
  "Local": "Local",
  "Code": "Code",
  "Prefix": "Prefix",
  "Region": "Region",
  "City": "City",
  "Timezone": "Timezone",
  "Carrier": "Carrier",
  "Line Type": "Line Type",
  "Messaging": "Messaging",
  "IP Lookup": "IP Lookup",
  "Look up geolocation, ISP, and threat data for any IP address.": "Look up geolocation, ISP, and threat data for any IP address.",
  "Enter IP address (e.g. 8.8.8.8)...": "Enter IP address (e.g. 8.8.8.8)...",
  "No valid IPs found in file": "No valid IPs found in file",
  "Unknown location": "Unknown location",
  "high risk": "high risk",
  "medium risk": "medium risk",
  "low risk": "low risk",
  "Geolocation": "Geolocation",
  "Country Code": "Country Code",
  "Postal Code": "Postal Code",
  "Continent": "Continent",
  "Latitude": "Latitude",
  "Longitude": "Longitude",
  "EU Member": "EU Member",
  "Yes": "Yes",
  "No": "No",
  "Security & Threats": "Security & Threats",
  "VPN": "VPN",
  "Proxy": "Proxy",
  "Tor": "Tor",
  "Hosting": "Hosting",
  "Relay": "Relay",
  "Mobile": "Mobile",
  "Abuse": "Abuse",
  "Google Lookup": "Google Lookup",
  "Search and discover information about any topic using Google.": "Search and discover information about any topic using Google.",
  "Enter search query...": "Enter search query...",
  "Search complete": "Search complete",
  "Search Google": "Search Google",
  "Enter a search query above to discover information across the web. Results will include titles, snippets, and source links.": "Enter a search query above to discover information across the web. Results will include titles, snippets, and source links.",
  "Dark Web Lookup": "Dark Web Lookup",
  "Search dark web intelligence - credential leaks, breach exposure, and threat monitoring.": "Search dark web intelligence - credential leaks, breach exposure, and threat monitoring.",
  "Search emails, domains, IPs, keywords...": "Search emails, domains, IPs, keywords...",
  "Dark web search complete": "Dark web search complete",
  "Failed to load more results": "Failed to load more results",
  "Content": "Content",
  "Type": "Type",
  "Date": "Date",
  "Hackishness": "Hackishness",
  "Dark Web Intelligence": "Dark Web Intelligence",
  "Search for anything, emails, domains, IPs, keywords to discover dark web exposure, credential leaks, and breach data.": "Search for anything, emails, domains, IPs, keywords to discover dark web exposure, credential leaks, and breach data.",
  "API keys": "API keys",
  "API keys are owned by workspaces and remain active even after the creator is removed": "API keys are owned by workspaces and remain active even after the creator is removed",
  "Do not share or expose your API keys in client-side code. Leaked keys may be automatically disabled to protect your account security.": "Do not share or expose your API keys in client-side code. Leaked keys may be automatically disabled to protect your account security.",
  "Create key": "Create key",
  "Create API key": "Create API key",
  "Key name": "Key name",
  "e.g. Production, Development...": "e.g. Production, Development...",
  "Name required": "Name required",
  "Give your API key a name.": "Give your API key a name.",
  "Creating...": "Creating...",
  "Your new API key": "Your new API key",
  "Copy it now - you won't be able to see the full key again.": "Copy it now - you won't be able to see the full key again.",
  "Dismiss": "Dismiss",
  "Copied!": "Copied!",
  "Click to copy": "Click to copy",
  "API key copied to clipboard": "API key copied to clipboard",
  "No API keys yet": "No API keys yet",
  "Create your first API key to start using the Encrata API.": "Create your first API key to start using the Encrata API.",
  "Status": "Status",
  "Creator": "Creator",
  "Last Used": "Last Used",
  "Usage": "Usage",
  "Active": "Active",
  "Disabled": "Disabled",
  "Never": "Never",
  "Just now": "Just now",
  "Full key unavailable": "Full key unavailable",
  "Full key unavailable - this key was created before key storage was enabled": "Full key unavailable - this key was created before key storage was enabled",
  "Edit name": "Edit name",
  "Disable API key": "Disable API key",
  "Re-enable API key": "Re-enable API key",
  "Delete API key": "Delete API key",
  "Failed to load API keys": "Failed to load API keys",
  "Failed to create key": "Failed to create key",
  "API key deleted": "API key deleted",
  "Failed to delete key": "Failed to delete key",
  "API key renamed": "API key renamed",
  "Failed to rename API key": "Failed to rename API key",
  "Copied to clipboard": "Copied to clipboard",
  "You don't have permission to view API keys.": "You don't have permission to view API keys.",
  "Contact your team admin for access.": "Contact your team admin for access.",
  "Automate enrichment pipelines by chaining lookups, conditions, and actions.": "Automate enrichment pipelines by chaining lookups, conditions, and actions.",
  "Steps": "Steps",
  "Runs": "Runs",
  "Last run": "Last run",
  "Manual": "Manual",
  "Webhook": "Webhook",
  "Schedule": "Schedule",
  "File Upload": "File Upload",
  "Monitor Event": "Monitor Event",
  "Pause": "Pause",
  "Activate": "Activate",
  "Delete": "Delete",
  "Email Lookup": "Email Lookup",
  "Condition": "Condition",
  "Delay": "Delay",
  "Transform": "Transform",
  "Enrich a person from an email": "Enrich a person from an email",
  "Enrich a person from a phone": "Enrich a person from a phone",
  "Look up company details": "Look up company details",
  "Resolve a domain to a company": "Resolve a domain to a company",
  "Geolocate and identify an IP": "Geolocate and identify an IP",
  "Scan breach databases": "Scan breach databases",
  "Branch on a field value": "Branch on a field value",
  "Pause for a set duration": "Pause for a set duration",
  "Send data to a URL": "Send data to a URL",
  "Reshape the data payload": "Reshape the data payload",
  "Triggered manually or via API": "Triggered manually or via API",
  "Triggered by an incoming webhook": "Triggered by an incoming webhook",
  "Runs on a recurring schedule": "Runs on a recurring schedule",
  "Triggered when a file is uploaded": "Triggered when a file is uploaded",
  "Triggered when a monitor detects changes": "Triggered when a monitor detects changes",
  "Not configured": "Not configured",
  "Trigger": "Trigger",
  "Configure": "Configure",
  "Duplicate": "Duplicate",
  "Add step below": "Add step below",
  "True": "True",
  "False": "False",
  "Failed to trigger run": "Failed to trigger run",
  "Settings": "Settings",
  "Run": "Run",
  "Running": "Running",
  "Save changes": "Save changes",
  "Saving": "Saving",
  "unconfigured": "unconfigured",
  "step": "step",
  "steps": "steps",
  "Incomplete": "Incomplete",
  "Ready": "Ready",
  "Add a step": "Add a step",
  "Search steps": "Search steps",
  "lookup": "lookup",
  "logic": "logic",
  "action": "action",
  "Label": "Label",
  "Step name": "Step name",
  "Field": "Field",
  "e.g. email": "e.g. email",
  "Operator": "Operator",
  "equals": "equals",
  "not equals": "not equals",
  "contains": "contains",
  "exists": "exists",
  "greater than": "greater than",
  "less than": "less than",
  "Value": "Value",
  "Comparison value": "Comparison value",
  "URL": "URL",
  "Method": "Method",
  "Delay (seconds)": "Delay (seconds)",
  "Expression": "Expression",
  "Input field": "Input field",
  "Reference data from a previous step or the trigger.": "Reference data from a previous step or the trigger.",
  "Delete step": "Delete step",
  "Description": "Description",
  "Draft": "Draft",
  "Paused": "Paused",
  "Frequency": "Frequency",
  "Select frequency": "Select frequency",
  "Every hour": "Every hour",
  "Every day": "Every day",
  "Every week": "Every week",
  "Every month": "Every month",
  "Credits": "Credits",
  "Duration": "Duration",
  "View details": "View details",
  "Cancel run": "Cancel run",
  "Delete run": "Delete run",
  "Showing": "Showing",
  "of": "of",
  "Previous": "Previous",
  "Next": "Next",
  "Run Details": "Run Details",
  "Run ID": "Run ID",
  "Failed to load runs": "Failed to load runs",
  "Failed to load run details": "Failed to load run details",
  "Cancellation requested": "Cancellation requested",
  "Failed to cancel run": "Failed to cancel run",
  "Run deleted": "Run deleted",
  "Failed to delete run": "Failed to delete run",
  "Secrets": "Secrets",
  "Add Secret": "Add Secret",
  "No secrets configured": "No secrets configured",
  "Display Name": "Display Name",
  "Secret Key": "Secret Key",
  "Create Secret": "Create Secret",
  "Failed to load secrets": "Failed to load secrets",
  "All fields are required": "All fields are required",
  "Secret created": "Secret created",
  "Failed to create secret": "Failed to create secret",
  "Secret deleted": "Secret deleted",
  "Failed to delete secret": "Failed to delete secret",
  "Templates": "Templates",
  "All": "All",
  "No templates found": "No templates found",
  "deployments": "deployments",
  "Deploy": "Deploy",
  "Sales & Lead Gen": "Sales & Lead Gen",
  "Security & Compliance": "Security & Compliance",
  "Research & Intelligence": "Research & Intelligence",
  "Monitoring": "Monitoring",
  "Fraud Detection": "Fraud Detection",
  "General": "General",
  "Failed to load templates": "Failed to load templates",
  "Search history": "Search history",
  "Your recent email lookups and results.": "Your recent email lookups and results.",
  "Clear all": "Clear all",
  "No search history": "No search history",
  "Your email lookups will appear here. Start by searching for an email address.": "Your email lookups will appear here. Start by searching for an email address.",
  "Start lookup": "Start lookup",
  "Failed to load history": "Failed to load history",
  "History cleared": "History cleared",
  "Failed to clear history": "Failed to clear history",
  "Email Activity": "Email Activity",
  "All email lookup activity - dashboard searches and API requests.": "All email lookup activity - dashboard searches and API requests.",
  "No email activity": "No email activity",
  "Activity logs": "Activity logs",
  "An overview of your latest requests.": "An overview of your latest requests.",
  "Total requests": "Total requests",
  "Success rate": "Success rate",
  "Avg response time": "Avg response time",
  "No activity yet": "No activity yet",
  "API request logs will appear here once you start making requests.": "API request logs will appear here once you start making requests.",
  "Search email or domain...": "Search email or domain...",
  "All methods": "All methods",
  "All endpoints": "All endpoints",
  "All statuses": "All statuses",
  "Endpoint": "Endpoint",
  "Time": "Time",
  "Response time": "Response time",
  "No logs match your filters.": "No logs match your filters.",
  "Clear filters": "Clear filters",
  "Refresh": "Refresh",
  "All time": "All time",
  "Last 24 hours": "Last 24 hours",
  "Last 30 days": "Last 30 days",
  "Dashboard": "Dashboard",
  "API": "API",
  "Query": "Query",
  "cURL": "cURL",
  "Python": "Python",
  "JavaScript": "JavaScript",
  "Go": "Go",
  "No JSON response available": "No JSON response available",
  "JSON is only stored for dashboard lookups.": "JSON is only stored for dashboard lookups.",
  "Request Info": "Request Info",
  "Latency": "Latency",
  "Your lookups and API requests will appear here.": "Your lookups and API requests will appear here.",
  "Team": "Team",
  "Members": "Members",
  "Manage who has access to your workspace.": "Manage who has access to your workspace.",
  "Invite": "Invite",
  "Invite team member": "Invite team member",
  "Send invite": "Send invite",
  "Email address": "Email address",
  "Role": "Role",
  "Admin": "Admin",
  "All privileges": "All privileges",
  "Tech": "Tech",
  "All except account deletion": "All except account deletion",
  "Read only": "Read only",
  "View only, no changes": "View only, no changes",
  "Remove member": "Remove member",
  "Remove": "Remove",
  "No team members yet": "No team members yet",
  "Invite your first member": "Invite your first member",
  "Member": "Member",
  "Joined": "Joined",
  "Pending": "Pending",
  "Please enter a valid email address": "Please enter a valid email address",
  "Invite sent": "Invite sent",
  "Failed to send invite": "Failed to send invite",
  "Role updated": "Role updated",
  "Failed to update role": "Failed to update role",
  "Member removed": "Member removed",
  "Failed to remove member": "Failed to remove member",
  "Failed to load team members": "Failed to load team members",
  "Billing": "Billing",
  "Manage your credits and top up when you need more.": "Manage your credits and top up when you need more.",
  "Encrata": "Encrata",
  "Available Credits": "Available Credits",
  "Account Holder": "Account Holder",
  "Workspace": "Workspace",
  "Personal": "Personal",
  "Purchase credits": "Purchase credits",
  "One-time purchase": "One-time purchase",
  "Total": "Total",
  "Processing...": "Processing...",
  "Contact Sales for Enterprise": "Contact Sales for Enterprise",
  "Complete Payment": "Complete Payment",
  "Auto top-up": "Auto top-up",
  "Automatically add credits": "Automatically add credits",
  "Top up when your balance falls below a threshold.": "Top up when your balance falls below a threshold.",
  "Add a payment method first": "Add a payment method first",
  "Auto top-up enabled": "Auto top-up enabled",
  "Auto top-up disabled": "Auto top-up disabled",
  "Failed to update": "Failed to update",
  "When balance drops below": "When balance drops below",
  "Top up amount": "Top up amount",
  "Payment methods": "Payment methods",
  "Update card": "Update card",
  "No payment method on file": "No payment method on file",
  "Add a card to purchase credits.": "Add a card to purchase credits.",
  "Add Card": "Add Card",
  "Update": "Update",
  "Remove this payment method?": "Remove this payment method?",
  "Payment method removed": "Payment method removed",
  "Failed to remove payment method": "Failed to remove payment method",
  "Billing History": "Billing History",
  "No payments yet": "No payments yet",
  "Your payment history will appear here after your first purchase.": "Your payment history will appear here after your first purchase.",
  "Amount": "Amount",
  "Invoice": "Invoice",
  "Paid": "Paid",
  "Refunded": "Refunded",
  "Canceled": "Canceled",
  "credits": "credits",
  "Receipt": "Receipt",
  "Failed to save card": "Failed to save card",
  "Card added successfully": "Card added successfully",
  "Failed to add card": "Failed to add card",
  "Saving...": "Saving...",
  "Payment failed": "Payment failed",
  "Payment was not completed. Please try again.": "Payment was not completed. Please try again.",
  "Payment is being processed...": "Payment is being processed...",
  "Payment system not ready": "Payment system not ready",
  "Failed to start purchase": "Failed to start purchase",
  "Profile": "Profile",
  "Full name": "Full name",
  "Phone": "Phone",
  "Change": "Change",
  "Enter new email address": "Enter new email address",
  "Send code": "Send code",
  "Sending...": "Sending...",
  "Enter the 6-digit code sent to": "Enter the 6-digit code sent to",
  "Resend code": "Resend code",
  "Confirm change": "Confirm change",
  "Verifying...": "Verifying...",
  "Appearance": "Appearance",
  "Theme": "Theme",
  "Light": "Light",
  "Dark": "Dark",
  "System": "System",
  "Workspace access": "Workspace access",
  "Remove yourself from workspace": "Remove yourself from workspace",
  "Leave workspace": "Leave workspace",
  "Session": "Session",
  "Log out": "Log out",
  "Sign out of your account on this device.": "Sign out of your account on this device.",
  "Danger zone": "Danger zone",
  "Delete account": "Delete account",
  "Permanently delete your account and all data. This cannot be undone.": "Permanently delete your account and all data. This cannot be undone.",
  "Send verification code": "Send verification code",
  "Sending code...": "Sending code...",
  "Profile updated": "Profile updated",
  "Failed to update profile": "Failed to update profile",
  "Workspace updated": "Workspace updated",
  "Failed to update workspace": "Failed to update workspace",
  "Verification code sent to your email": "Verification code sent to your email",
  "Failed to send code": "Failed to send code",
  "Email updated successfully": "Email updated successfully",
  "Verification failed": "Verification failed",
  "Account deleted": "Account deleted",
  "You have left the workspace": "You have left the workspace",
  "Security": "Security",
  "Password": "Password",
  "Change password": "Change password",
  "Current password": "Current password",
  "Enter current password": "Enter current password",
  "New password": "New password",
  "Min 8 characters": "Min 8 characters",
  "Confirm new password": "Confirm new password",
  "Re-enter new password": "Re-enter new password",
  "Changing...": "Changing...",
  "Sessions": "Sessions",
  "Loading sessions...": "Loading sessions...",
  "Current session": "Current session",
  "active session": "active session",
  "active sessions": "active sessions",
  "Revoke all": "Revoke all",
  "Last seen": "Last seen",
  "Revoke": "Revoke",
  "No active sessions": "No active sessions",
  "Two-factor authentication": "Two-factor authentication",
  "2FA is enabled": "2FA is enabled",
  "Your account is protected with an authenticator app.": "Your account is protected with an authenticator app.",
  "Disable": "Disable",
  "Enter a code from your authenticator app to disable 2FA.": "Enter a code from your authenticator app to disable 2FA.",
  "Disabling...": "Disabling...",
  "Confirm disable": "Confirm disable",
  "Scan QR code": "Scan QR code",
  "Or enter this code manually:": "Or enter this code manually:",
  "Enter the 6-digit code from your authenticator app to verify:": "Enter the 6-digit code from your authenticator app to verify:",
  "Enable 2FA": "Enable 2FA",
  "Authenticator app": "Authenticator app",
  "Use an authenticator app to generate one-time codes.": "Use an authenticator app to generate one-time codes.",
  "Set up": "Set up",
  "Backup codes": "Backup codes",
  "Save these codes in a safe place. You can use them to access your account if you lose your authenticator device.": "Save these codes in a safe place. You can use them to access your account if you lose your authenticator device.",
  "New password must be at least 8 characters": "New password must be at least 8 characters",
  "Passwords do not match": "Passwords do not match",
  "Password changed successfully": "Password changed successfully",
  "Failed to change password": "Failed to change password",
  "Session revoked": "Session revoked",
  "Failed to revoke session": "Failed to revoke session",
  "All other sessions revoked": "All other sessions revoked",
  "Failed to revoke sessions": "Failed to revoke sessions",
  "Failed to start 2FA setup": "Failed to start 2FA setup",
  "2FA enabled successfully": "2FA enabled successfully",
  "Invalid code": "Invalid code",
  "2FA disabled": "2FA disabled",
  "Secret key copied": "Secret key copied",
  "Notifications": "Notifications",
  "Workspace invitations": "Workspace invitations",
  "When someone invites you to a workspace": "When someone invites you to a workspace",
  "Member joins or leaves": "Member joins or leaves",
  "When a member joins or is removed from your workspace": "When a member joins or is removed from your workspace",
  "API key created": "API key created",
  "When a new API key is created in your workspace": "When a new API key is created in your workspace",
  "Low credits warning": "Low credits warning",
  "When your credit balance falls below 100": "When your credit balance falls below 100",
  "Credits exhausted": "Credits exhausted",
  "When your credits reach zero": "When your credits reach zero",
  "Weekly summary": "Weekly summary",
  "A weekly digest of workspace activity and usage": "A weekly digest of workspace activity and usage",
  "Product updates": "Product updates",
  "New features, improvements, and announcements": "New features, improvements, and announcements",
  "Monitor changes": "Monitor changes",
  "When a monitor run detects changes or high-value alerts": "When a monitor run detects changes or high-value alerts",
  "Preference updated": "Preference updated",
  "Failed to save preference": "Failed to save preference",
  "Webhooks": "Webhooks",
  "Receive real-time HTTP callbacks when events happen in your workspace.": "Receive real-time HTTP callbacks when events happen in your workspace.",
  "Lookup Completed": "Lookup Completed",
  "When an email lookup finishes": "When an email lookup finishes",
  "API Key Created": "API Key Created",
  "When a new API key is generated": "When a new API key is generated",
  "API Key Revoked": "API Key Revoked",
  "When an API key is revoked": "When an API key is revoked",
  "Credits Low": "Credits Low",
  "When credits drop below threshold": "When credits drop below threshold",
  "Credits Exhausted": "Credits Exhausted",
  "When credits run out": "When credits run out",
  "Add webhook": "Add webhook",
  "No webhooks configured": "No webhooks configured",
  "Add a webhook to receive real-time notifications when events occur.": "Add a webhook to receive real-time notifications when events occur.",
  "Test": "Test",
  "Logs": "Logs",
  "Edit": "Edit",
  "Delete Webhook": "Delete Webhook",
  "This will permanently remove this webhook and all its delivery logs.": "This will permanently remove this webhook and all its delivery logs.",
  "Delivery Logs": "Delivery Logs",
  "No deliveries yet": "No deliveries yet",
  "Event": "Event",
  "HTTP": "HTTP",
  "Attempts": "Attempts",
  "Webhook Created": "Webhook Created",
  "Save this signing secret - you won't be able to see it again.": "Save this signing secret - you won't be able to see it again.",
  "Signing Secret": "Signing Secret",
  "Copy": "Copy",
  "Secret copied": "Secret copied",
  "Done": "Done",
  "Edit Webhook": "Edit Webhook",
  "Add Webhook": "Add Webhook",
  "Endpoint URL": "Endpoint URL",
  "Events": "Events",
  "Create": "Create",
  "Webhook paused": "Webhook paused",
  "Webhook enabled": "Webhook enabled",
  "Test event sent": "Test event sent",
  "Failed to send test event": "Failed to send test event",
  "Webhook deleted": "Webhook deleted",
  "Failed to delete webhook": "Failed to delete webhook",
  "Failed to load deliveries": "Failed to load deliveries",
  "Webhook updated": "Webhook updated",
  "Webhook created": "Webhook created",
  "Failed to save webhook": "Failed to save webhook",
  "Track your credit usage and transaction history.": "Track your credit usage and transaction history.",
  "This month usage": "This month usage",
  "Total credits used": "Total credits used",
  "Credit history": "Credit history",
  "No transactions yet": "No transactions yet",
  "Credit purchases and usage will appear here.": "Credit purchases and usage will appear here.",
  "Top-up": "Top-up",
  "Refund": "Refund",
  "Bonus": "Bonus",
  "Signup": "Signup",
  "total entries": "total entries",
  "Page": "Page",
  "Icon": "Icon",
  "Slug": "Slug",
  "Delete workspace": "Delete workspace",
  "Permanently delete this workspace and all its data.": "Permanently delete this workspace and all its data.",
  "Deleting...": "Deleting...",
  "Logo must be under 2MB": "Logo must be under 2MB",
  "Only PNG, JPEG, WebP, or SVG allowed": "Only PNG, JPEG, WebP, or SVG allowed",
  "Logo updated": "Logo updated",
  "Failed to upload logo": "Failed to upload logo",
  "Workspace deleted": "Workspace deleted",
  "Failed to delete workspace": "Failed to delete workspace",
  "Integrations": "Integrations",
  "Soon": "Soon",
  "Sync enriched contacts to HubSpot CRM": "Sync enriched contacts to HubSpot CRM",
  "Push enriched leads to Salesforce": "Push enriched leads to Salesforce",
  "Enrich and sync deals in Pipedrive": "Enrich and sync deals in Pipedrive",
  "Sync contacts and companies to Attio": "Sync contacts and companies to Attio",
  "Connect to 6,000+ apps via Zapier": "Connect to 6,000+ apps via Zapier",
  "Get lookup alerts in Slack channels": "Get lookup alerts in Slack channels",
  "Export enriched data to Google Sheets": "Export enriched data to Google Sheets",
  "Trigger enrichment from GitLab pipelines": "Trigger enrichment from GitLab pipelines",
  "Error monitoring and alerting": "Error monitoring and alerting",
  "AI Agents": "AI Agents",
  "Coming soon": "Coming soon",
  "AI-powered automation": "AI-powered automation",
  "Refer & earn credits": "Refer & earn credits",
  "Friends don't let friends pay full price": "Friends don't let friends pay full price",
  "Your referral link": "Your referral link",
  "Copied": "Copied",
  "Copy link": "Copy link",
  "Friends referred": "Friends referred",
  "Credits earned": "Credits earned",
  "Referral history": "Referral history",
  "Awaiting purchase": "Awaiting purchase",
  "How it works": "How it works",
  "Share your link": "Share your link",
  "Send your referral link to a friend who'd love Encrata.": "Send your referral link to a friend who'd love Encrata.",
  "They join Encrata": "They join Encrata",
  "Your friend signs up using your link.": "Your friend signs up using your link.",
  "You both get rewarded": "You both get rewarded",
  "Failed to load referral data": "Failed to load referral data",
  "Referral link copied!": "Referral link copied!",
  "Refer & earn": "Refer & earn",
  "Single Sign-On (SSO)": "Single Sign-On (SSO)",
  "Configure OIDC-based SSO for your organization.": "Configure OIDC-based SSO for your organization.",
  "Only workspace admins can configure SSO.": "Only workspace admins can configure SSO.",
  "Azure AD (Entra ID)": "Azure AD (Entra ID)",
  "Okta": "Okta",
  "Google Workspace": "Google Workspace",
  "Custom OIDC": "Custom OIDC",
  "Enforced": "Enforced",
  "logins": "logins",
  "Disable Enforce": "Disable Enforce",
  "Enforce SSO": "Enforce SSO",
  "No SSO connections configured yet.": "No SSO connections configured yet.",
  "Edit SSO Connection": "Edit SSO Connection",
  "New SSO Connection": "New SSO Connection",
  "Add SSO Connection": "Add SSO Connection",
  "Identity Provider": "Identity Provider",
  "Issuer URL": "Issuer URL",
  "Testing...": "Testing...",
  "Client ID": "Client ID",
  "Client Secret": "Client Secret",
  "Email Domain": "Email Domain",
  "Scopes": "Scopes",
  "Block password/OAuth login for users with this domain": "Block password/OAuth login for users with this domain",
  "Auto-provision users": "Auto-provision users",
  "Automatically create accounts on first SSO login": "Automatically create accounts on first SSO login",
  "Default Role for New Members": "Default Role for New Members",
  "Redirect URI (add this to your IdP)": "Redirect URI (add this to your IdP)",
  "Update Connection": "Update Connection",
  "Create Connection": "Create Connection",
  "OIDC discovery successful - provider is reachable": "OIDC discovery successful - provider is reachable",
  "Failed to reach provider": "Failed to reach provider",
  "Failed to test connection": "Failed to test connection",
  "Please fill in all required fields": "Please fill in all required fields",
  "SSO connection updated": "SSO connection updated",
  "SSO connection created": "SSO connection created",
  "Failed to save": "Failed to save",
  "Failed to save connection": "Failed to save connection",
  "SSO connection deleted": "SSO connection deleted",
  "Failed to delete": "Failed to delete",
  "SSO enforcement disabled": "SSO enforcement disabled",
  "SSO enforcement enabled": "SSO enforcement enabled",
  "Welcome back": "Welcome back",
  "Sign in to your account": "Sign in to your account",
  "you@company.com": "you@company.com",
  "Forgot password?": "Forgot password?",
  "Signing in...": "Signing in...",
  "Sign in": "Sign in",
  "or": "or",
  "Sign in with magic link": "Sign in with magic link",
  "Continue with Google": "Continue with Google",
  "Continue with GitHub": "Continue with GitHub",
  "Sign in with SSO": "Sign in with SSO",
  "Your organization requires SSO login for this domain.": "Your organization requires SSO login for this domain.",
  "Send magic link": "Send magic link",
  "Sign in with password": "Sign in with password",
  "Don't have an account?": "Don't have an account?",
  "Sign up": "Sign up",
  "Check your email": "Check your email",
  "The link expires in 15 minutes.": "The link expires in 15 minutes.",
  "Back to sign in": "Back to sign in",
  "Signed in successfully": "Signed in successfully",
  "Invalid or expired magic link": "Invalid or expired magic link",
  "Login failed": "Login failed",
  "Check your email for a sign-in link": "Check your email for a sign-in link",
  "Request failed": "Request failed",
  "Signing you in...": "Signing you in...",
  "Create your account": "Create your account",
  "Start using Encrata for free": "Start using Encrata for free",
  "John Doe": "John Doe",
  "Creating account...": "Creating account...",
  "Create account": "Create account",
  "Already have an account?": "Already have an account?",
  "Check your email for a verification code": "Check your email for a verification code",
  "Signup failed": "Signup failed",
  "Reset your password": "Reset your password",
  "Enter your email and we'll send you a reset link": "Enter your email and we'll send you a reset link",
  "Send reset link": "Send reset link",
  "Remember your password?": "Remember your password?",
  "Set a new password": "Set a new password",
  "Choose a strong password for your account": "Choose a strong password for your account",
  "Confirm password": "Confirm password",
  "Re-enter password": "Re-enter password",
  "Resetting...": "Resetting...",
  "Reset password": "Reset password",
  "Invalid reset link": "Invalid reset link",
  "This link is missing or malformed. Request a new one.": "This link is missing or malformed. Request a new one.",
  "Request new link": "Request new link",
  "Password updated": "Password updated",
  "Redirecting you to sign in...": "Redirecting you to sign in...",
  "Passwords don't match": "Passwords don't match",
  "Password reset successfully": "Password reset successfully",
  "Reset failed": "Reset failed",
  "Verify your email": "Verify your email",
  "Enter the 6-digit code sent to your email": "Enter the 6-digit code sent to your email",
  "Verify email": "Verify email",
  "Didn't get a code?": "Didn't get a code?",
  "Please enter the 6-digit code": "Please enter the 6-digit code",
  "Email verified!": "Email verified!",
  "New code sent to your email": "New code sent to your email",
  "Failed to resend": "Failed to resend",
  "Create your workspace": "Create your workspace",
  "Workspaces are shared environments where your team collaborates.": "Workspaces are shared environments where your team collaborates.",
  "Workspace name": "Workspace name",
  "URL slug": "URL slug",
  "Continue": "Continue",
  "Invite your team": "Invite your team",
  "Add teammates to your workspace. You can always do this later.": "Add teammates to your workspace. You can always do this later.",
  "Add": "Add",
  "Skip for now": "Skip for now",
  "Send invites": "Send invites",
  "Workspace name is required": "Workspace name is required",
  "Already added": "Already added",
  "Invites sent!": "Invites sent!",
  "Failed to create workspace": "Failed to create workspace",
  "Failed to send invites": "Failed to send invites",
  "Sandbox": "Sandbox",
  "Data Fields": "Data Fields",
  "All fields": "All fields",
  "Output format": "Output format",
  "Enriched": "Enriched",
  "Output": "Output",
  "credit": "credit",
  "used": "used",
  "Enter an email and hit Search to see results.": "Enter an email and hit Search to see results.",
  "Fetching results...": "Fetching results...",
  "Email Lookup Result": "Email Lookup Result",
  "Identity": "Identity",
  "Professional": "Professional",
  "Education": "Education",
  "Social Profiles": "Social Profiles",
  "Interests & Topics": "Interests & Topics",
  "Verification": "Verification",
  "Security & Breaches": "Security & Breaches",
  "IP Intelligence": "IP Intelligence",
  "Research": "Research",
  "Java": "Java",
  "C#": "C#",
  "PHP": "PHP",
  "Ruby": "Ruby",
  "404": "404",
  "Page not found": "Page not found",
  "The page you're looking for doesn't exist or has been moved.": "The page you're looking for doesn't exist or has been moved.",
  "Something went wrong": "Something went wrong",
  "An unexpected error occurred.": "An unexpected error occurred.",
  "Go home": "Go home",
  "Private beta - early access coming soon": "Private beta - early access coming soon",
  "The intelligence API": "The intelligence API",
  "for emails, domains & IPs": "for emails, domains & IPs",
  "Join waitlist": "Join waitlist",
  "people already on the waitlist": "people already on the waitlist",
  "We'll let you know when it's your turn.": "We'll let you know when it's your turn.",
  "Simple, credit-based pricing": "Simple, credit-based pricing",
  "Pay only for what you use. No monthly minimums, no hidden fees. Every lookup costs 1 credit.": "Pay only for what you use. No monthly minimums, no hidden fees. Every lookup costs 1 credit.",
  "Monthly": "Monthly",
  "Annual": "Annual",
  "Most popular": "Most popular",
  "Starter": "Starter",
  "forever": "forever",
  "Pro": "Pro",
  "Enterprise": "Enterprise",
  "Custom": "Custom",
  "Unlimited": "Unlimited",
  "Get started": "Get started",
  "Start free trial": "Start free trial",
  "Contact sales": "Contact sales",
  "Create free account": "Create free account",
  "Credit costs per endpoint": "Credit costs per endpoint",
  "Every lookup type costs the same. Simple.": "Every lookup type costs the same. Simple.",
  "Cost": "Cost",
  "1 credit": "1 credit",
  "Email enrichment": "Email enrichment",
  "Google search": "Google search",
  "Company lookup": "Company lookup",
  "IP lookup": "IP lookup",
  "Phone lookup": "Phone lookup",
  "Dark web search": "Dark web search",
  "Email validation": "Email validation",
  "Breach check": "Breach check",
  "Pricing FAQ": "Pricing FAQ",
  "Ready to get started?": "Ready to get started?",
  "Sign up free and get 50 credits to test the API. No credit card required.": "Sign up free and get 50 credits to test the API. No credit card required.",
  "Save": "Save",
  "Close": "Close",
  "Confirm": "Confirm",
  "Back": "Back",
  "Show more": "Show more",
  "Show less": "Show less",
  "Success": "Success",
  "Error": "Error",
  "Warning": "Warning",
  "Info": "Info",
  "OK": "OK",
  "selected": "selected",
  "Language": "Language",
  "About": "About",
  "Age": "Age",
  "Birthplace": "Birthplace",
  "Gender": "Gender",
  "Ethnicity": "Ethnicity",
  "Nationality": "Nationality",
  "Social profiles": "Social profiles",
  "Services": "Services",
  "Interests": "Interests",
  "Registered on": "Registered on",
  "Level": "Level",
  "University": "University",
  "Field of Study": "Field of Study",
  "Breach Date": "Breach Date",
  "Data Exposed": "Data Exposed",
  "Person not found": "Person not found",
  "Back to lookup": "Back to lookup",
  "Company info": "Company info",
  "Experience": "Experience",
  "Recent news": "Recent news",
  "Academic papers": "Academic papers",
  "Patents": "Patents",
  "People also ask": "People also ask",
  "Related topics": "Related topics",
  "Professional profile": "Professional profile",
  "Work history": "Work history",
  "Certifications": "Certifications",
  "Languages": "Languages",
  "Skills": "Skills",
  "Company size": "Company size",
  "Est. salary": "Est. salary",
  "In role since": "In role since",
  "Category": "Category",
  "Details": "Details",
  "Rating": "Rating",
  "Present": "Present",
  "Service": "Service",
  "LinkedIn": "LinkedIn",
  "Twitter / X": "Twitter / X",
  "Instagram": "Instagram",
  "Facebook": "Facebook",
  "GitHub": "GitHub",
  "Phone Number": "Phone Number",
  "Line Status": "Line Status",
  "Line Valid": "Line Valid",
  "Line Invalid": "Line Invalid",
  "VoIP": "VoIP",
  "Non-VoIP": "Non-VoIP",
  "Location & Format": "Location & Format",
  "SMS Domain": "SMS Domain",
  "SMS Email": "SMS Email",
  "Knowledge Graph": "Knowledge Graph",
  "Organic Results": "Organic Results",
  "People Also Ask": "People Also Ask",
  "Related Searches": "Related Searches",
  "Related searches": "Related searches",
  "Answer Box": "Answer Box",
  "Images": "Images",
  "Videos": "Videos",
  "News": "News",
  "Shopping": "Shopping",
  "Maps": "Maps",
  "Places": "Places",
  "Scholar": "Scholar",
  "Autocomplete": "Autocomplete",
  "Total Results": "Total Results",
  "Company Profile": "Company Profile",
  "Company Snapshot": "Company Snapshot",
  "Specialties": "Specialties",
  "Subsidiaries": "Subsidiaries",
  "Acquisitions": "Acquisitions",
  "Industries": "Industries",
  "Shareholders (PSC)": "Shareholders (PSC)",
  "Officers & Directors": "Officers & Directors",
  "Officers": "Officers",
  "Persons with Significant Control": "Persons with Significant Control",
  "NAICS Codes": "NAICS Codes",
  "SIC Codes": "SIC Codes",
  "Monthly Visits": "Monthly Visits",
  "WHOIS": "WHOIS",
  "Registrant": "Registrant",
  "Nameservers": "Nameservers",
  "SSL Certificate": "SSL Certificate",
  "Related Domains": "Related Domains",
  "Emails Found": "Emails Found",
  "Registration": "Registration",
  "Websites": "Websites",
  "Registry Records": "Registry Records",
  "Technologies": "Technologies",
  "Timezone & Currency": "Timezone & Currency",
  "Local Time": "Local Time",
  "UTC Offset": "UTC Offset",
  "Currency": "Currency",
  "Network": "Network",
  "Tor Exit": "Tor Exit",
  "Abuse Confidence": "Abuse Confidence",
  "Abuse Detected": "Abuse Detected",
  "No Abuse Signal": "No Abuse Signal",
  "Reports": "Reports",
  "Reporters": "Reporters",
  "Last Reported": "Last Reported",
  "Usage Type": "Usage Type",
  "Host Intelligence": "Host Intelligence",
  "Threat Intelligence": "Threat Intelligence",
  "Threat Intel": "Threat Intel",
  "Malicious": "Malicious",
  "Suspicious": "Suspicious",
  "Harmless": "Harmless",
  "Undetected": "Undetected",
  "Reputation": "Reputation",
  "Reputation score": "Reputation score",
  "Risk Level": "Risk Level",
  "Risk": "Risk",
  "Vendor Detections": "Vendor Detections",
  "Malware Analysis": "Malware Analysis",
  "Malware Signals": "Malware Signals",
  "Vulnerabilities": "Vulnerabilities",
  "CVEs": "CVEs",
  "Validation & Risk": "Validation & Risk",
  "ISP Domain": "ISP Domain",
  "Org Domain": "Org Domain",
  "Org Type": "Org Type",
  "Breach Exposure": "Breach Exposure",
  "Breach Results": "Breach Results",
  "Breaches": "Breaches",
  "Total Breaches": "Total Breaches",
  "First Breached": "First Breached",
  "Last Breached": "Last Breached",
  "Credential Leak": "Credential Leak",
  "Paste": "Paste",
  "Paste Details": "Paste Details",
  "Forum": "Forum",
  "Forum Details": "Forum Details",
  "Leak": "Leak",
  "Leak Details": "Leak Details",
  "Chat": "Chat",
  "Chat Details": "Chat Details",
  "Market": "Market",
  "Market Listing": "Market Listing",
  "Thread ID": "Thread ID",
  "Threads": "Threads",
  "Emails": "Emails",
  "IP Addresses": "IP Addresses",
  "SSNs Detected": "SSNs Detected",
  "Credit Card Numbers": "Credit Card Numbers",
  "Crypto Addresses": "Crypto Addresses",
  "Actors": "Actors",
  "Groups": "Groups",
  "IRC Details": "IRC Details",
  "Social Media": "Social Media",
  "Any time": "Any time",
  "Past 24 hours": "Past 24 hours",
  "Past hour": "Past hour",
  "Past week": "Past week",
  "Past month": "Past month",
  "Past year": "Past year",
  "Disposable": "Disposable",
  "Not Disposable": "Not Disposable",
  "Unknown": "Unknown",
  "Listed": "Listed",
  "Whitelisted": "Whitelisted",
  "Not found": "Not found",
  "Context": "Context",
  "Key": "Key",
  "Published": "Published",
  "Posted": "Posted",
  "Author": "Author",
  "Year": "Year",
  "Cited": "Cited",
  "Inventor": "Inventor",
  "Patent ID": "Patent ID",
  "Price": "Price",
  "Ships From": "Ships From",
  "Ships To": "Ships To",
  "Vendor": "Vendor",
  "Listing ID": "Listing ID",
  "Post Author": "Post Author",
  "Post Date": "Post Date",
  "Full Content": "Full Content",
  "Channel": "Channel",
  "Users": "Users",
  "Server": "Server",
  "Tags": "Tags",
  "Scanner": "Scanner",
  "Classification": "Classification",
  "Host": "Host",
  "Abbreviation": "Abbreviation",
  "Validation": "Validation",
  "Stock": "Stock",
  "Symbol": "Symbol",
  "Exchange": "Exchange",
  "Entities": "Entities",
  "Associations": "Associations",
  "Failed to load": "Failed to load",
  "Failed to delete entries": "Failed to delete entries",
  "Failed to create bulk job": "Failed to create bulk job",
  "This IP result could not be found.": "This IP result could not be found.",
  "This company result could not be found.": "This company result could not be found.",
  "This domain result could not be found.": "This domain result could not be found.",
  "This search result could not be found.": "This search result could not be found.",
  "This result is no longer available.": "This result is no longer available.",
  "No exposures found": "No exposures found",
  "No threats detected": "No threats detected",
  "Medium": "Medium",
  "High": "High",
  "Low": "Low",
  "None": "None",
  "Default": "Default",
  "First Seen": "First Seen",
  "Known Service": "Known Service",
  "File Size": "File Size",
  "Filename": "Filename",
  "Filepath": "Filepath",
  "Hash Type": "Hash Type",
  "Last analyzed": "Last analyzed",
  "Crawl Date": "Crawl Date",
  "Maximum 1,000 results reached": "Maximum 1,000 results reached",
  "View object": "View object",
  "Additional Fields": "Additional Fields",
  "Result not found": "Result not found",
  // ── Marketing site ──
  "Developers": "Developers",
  "Person data from any email": "Person data from any email",
  "Carrier, line type & owner": "Carrier, line type & owner",
  "Domains": "Domains",
  "WHOIS, DNS & tech stack": "WHOIS, DNS & tech stack",
  "Companies": "Companies",
  "Firmographics & funding": "Firmographics & funding",
  "IP address": "IP address",
  "Geo, ASN & risk scoring": "Geo, ASN & risk scoring",
  "Structured search results": "Structured search results",
  "Darkweb": "Darkweb",
  "Breaches & leaked data": "Breaches & leaked data",
  "Web scraper": "Web scraper",
  "Any page to clean JSON": "Any page to clean JSON",
  "API docs": "API docs",
  "Guides & API reference": "Guides & API reference",
  "Connect your AI assistant": "Connect your AI assistant",
  "Change log": "Change log",
  "What's new in the API": "What's new in the API",
  "Lookups from your terminal": "Lookups from your terminal",
  "Uptime & incidents": "Uptime & incidents",
  "About us": "About us",
  "Who we are & our mission": "Who we are & our mission",
  "Careers": "Careers",
  "Join the team": "Join the team",
  "Academy": "Academy",
  "Learn OSINT & enrichment": "Learn OSINT & enrichment",
  "Blogs": "Blogs",
  "News, guides & deep dives": "News, guides & deep dives",
  "Pricing": "Pricing",
  "Contact": "Contact",
  "Log in": "Log in",
  "One API.": "One API.",
  "Infinite lookups.": "Infinite lookups.",
  "APIs that help humans, AI agents, and businesses": "APIs that help humans, AI agents, and businesses",
  "find the information they need.": "find the information they need.",
  "Start with 500 free credits": "Start with 500 free credits",
  "Documentation": "Documentation",
  "Trusted by leading developers and enterprises": "Trusted by leading developers and enterprises",
  "Read all stories": "Read all stories",
  "Every lookup, one platform": "Every lookup, one platform",
  "Email, phone, Google, company, domain, IP, dark web, scraping, and": "Email, phone, Google, company, domain, IP, dark web, scraping, and",
  "Dark web": "Dark web",
  "Name, job title, company, location, bio, social profiles, breach history, and email validation - all from a single email address.": "Name, job title, company, location, bio, social profiles, breach history, and email validation - all from a single email address.",
  "Carrier, line type, location, and owner intelligence from any phone number - validate, score, and enrich numbers worldwide in real time.": "Carrier, line type, location, and owner intelligence from any phone number - validate, score, and enrich numbers worldwide in real time.",
  "Real-time Google search results with structured data extraction - find what the internet knows about anyone or anything, ranked and parsed.": "Real-time Google search results with structured data extraction - find what the internet knows about anyone or anything, ranked and parsed.",
  "Industry, size, funding, tech stack, social presence, and key personnel - comprehensive company intelligence from a single domain or name.": "Industry, size, funding, tech stack, social presence, and key personnel - comprehensive company intelligence from a single domain or name.",
  "WHOIS data, DNS records, SSL certificates, hosting info, and technology stack - instant, structured intelligence on any domain you query.": "WHOIS data, DNS records, SSL certificates, hosting info, and technology stack - instant, structured intelligence on any domain you query.",
  "Geolocation, ISP, ASN, abuse contacts, reverse DNS, and risk scoring for any IPv4 or IPv6 address - flag proxies, VPNs, and threats fast.": "Geolocation, ISP, ASN, abuse contacts, reverse DNS, and risk scoring for any IPv4 or IPv6 address - flag proxies, VPNs, and threats fast.",
  "Search breached databases and dark web dumps - find exposed credentials, passwords, and leaked personal data tied to any email or domain.": "Search breached databases and dark web dumps - find exposed credentials, passwords, and leaked personal data tied to any email or domain.",
  "Extract structured data from any web page on demand with a single API call - render JavaScript, bypass blocks, and get clean JSON back.": "Extract structured data from any web page on demand with a single API call - render JavaScript, bypass blocks, and get clean JSON back.",
  "API reference": "API reference",
  "Built for builders": "Built for builders",
  "Search, automate, and ship - with mockups powered by the same": "Search, automate, and ship - with mockups powered by the same",
  "components and API that run in production.": "components and API that run in production.",
  "Simple, powerful API": "Simple, powerful API",
  "One request. Rich, structured data.": "One request. Rich, structured data.",
  "Use it from any language.": "Use it from any language.",
  "Frequently asked questions": "Frequently asked questions",
  "Got questions? We've got answers.": "Got questions? We've got answers.",
  "What is Encrata?": "What is Encrata?",
  "What lookups does Encrata support?": "What lookups does Encrata support?",
  "How does it work?": "How does it work?",
  "Pick a lookup, pass your query, and get back structured JSON with everything we find - person data, carrier info, DNS records, geolocation, breach data, scraped content, and more.": "Pick a lookup, pass your query, and get back structured JSON with everything we find - person data, carrier info, DNS records, geolocation, breach data, scraped content, and more.",
  "How does billing work?": "How does billing work?",
  "Simple credit-based billing - you pay only for what you use, with no monthly minimums or hidden fees. Every account starts with free credits so you can test the API first.": "Simple credit-based billing - you pay only for what you use, with no monthly minimums or hidden fees. Every account starts with free credits so you can test the API first.",
  "Can I use it with my AI assistant?": "Can I use it with my AI assistant?",
  "What data sources do you use?": "What data sources do you use?",
  "We aggregate data from multiple real-time sources and proprietary datasets. All data is sourced from publicly available information.": "We aggregate data from multiple real-time sources and proprietary datasets. All data is sourced from publicly available information.",
  "When will Encrata launch?": "When will Encrata launch?",
  "We're currently in private beta. Join the waitlist and we'll notify you as soon as spots open up. Early waitlist members get priority access and bonus credits.": "We're currently in private beta. Join the waitlist and we'll notify you as soon as spots open up. Early waitlist members get priority access and bonus credits.",
  "Built for humans and AI.": "Built for humans and AI.",
  "All systems operational": "All systems operational",
  "Product": "Product",
  "Quickstart": "Quickstart",
  "API Reference": "API Reference",
  "SDKs": "SDKs",
  "Changelog": "Changelog",
  "Resources": "Resources",
  "Blog": "Blog",
  "Guides": "Guides",
  "Support": "Support",
  "Community": "Community",
  "Legal": "Legal",
  "Legal Hub": "Legal Hub",
  "Privacy Policy": "Privacy Policy",
  "Terms of Service": "Terms of Service",
  "Acceptable Use": "Acceptable Use",
  "Subprocessors": "Subprocessors",
  "Talk to us": "Talk to us",
  "Whether you're evaluating Encrata for your team, need help with integration,": "Whether you're evaluating Encrata for your team, need help with integration,",
  "or want to discuss enterprise plans, we're here.": "or want to discuss enterprise plans, we're here.",
  "Sales & support email": "Sales & support email",
  "Evaluating Encrata for your team or need technical support? Email us.": "Evaluating Encrata for your team or need technical support? Email us.",
  "We're here to help. Ask product questions, report problems, or leave feedback.": "We're here to help. Ask product questions, report problems, or leave feedback.",
  "Chat with us": "Chat with us",
  "Get instant answers from our team. Average response time is under a few minutes.": "Get instant answers from our team. Average response time is under a few minutes.",
  "Start a chat": "Start a chat",
  "Call or text us": "Call or text us",
  "Prefer to talk? Call or text us anytime and we'll pick up or get back to you fast.": "Prefer to talk? Call or text us anytime and we'll pick up or get back to you fast.",
  "Scan the QR code with your phone or tap the link to start a WhatsApp chat with us.": "Scan the QR code with your phone or tap the link to start a WhatsApp chat with us.",
  "Chat on WhatsApp": "Chat on WhatsApp",
  "Schedule a call": "Schedule a call",
  "Book a time that works for you and we'll walk you through anything you need.": "Book a time that works for you and we'll walk you through anything you need.",
  "Book a time": "Book a time",
  "Follow us": "Follow us",

  // ── Careers ──
  "Long Live The Wild Ones.": "Long Live The Wild Ones.",
  "It's difficult to describe this quality with words and impossible to measure it in numbers, but you can feel it when it's there. You know it when you experience it.": "It's difficult to describe this quality with words and impossible to measure it in numbers, but you can feel it when it's there. You know it when you experience it.",
  "Building this requires a team of talented individuals who care deeply about the quality of their work. If that sounds like you, please reach out and join us on our quest.": "Building this requires a team of talented individuals who care deeply about the quality of their work. If that sounds like you, please reach out and join us on our quest.",
  "Home office allowance": "Home office allowance",
  "Get your home setup primed for optimal flow.": "Get your home setup primed for optimal flow.",
  "Unlimited sick days": "Unlimited sick days",
  "Take the time you need to rest, recover, and get back on track.": "Take the time you need to rest, recover, and get back on track.",
  "Annual in-person retreat": "Annual in-person retreat",
  "Travel and meet up with the entire team around the world.": "Travel and meet up with the entire team around the world.",
  "Family leave": "Family leave",
  "Bond with your new biological or adopted child.": "Bond with your new biological or adopted child.",
  "Paid time off": "Paid time off",
  "Take time off to recharge and come back refreshed.": "Take time off to recharge and come back refreshed.",
  "Health, dental, vision": "Health, dental, vision",
  "Comprehensive coverage for you and your family.": "Comprehensive coverage for you and your family.",
  "Retirement account provided to invest in your future.": "Retirement account provided to invest in your future.",
  "Pension contributions": "Pension contributions",
  "Support for your local pension scheme.": "Support for your local pension scheme.",
  "Health insurance": "Health insurance",
  "Care for your family and loved ones.": "Care for your family and loved ones.",
  "Global": "Global",
  "USA": "USA",
  "EU": "EU",
  "India": "India",
  "Open Roles": "Open Roles",
  "Help us build the future of data intelligence. We're looking for talented people who are passionate about what they do.": "Help us build the future of data intelligence. We're looking for talented people who are passionate about what they do.",
  "Loading positions...": "Loading positions...",
  "No open positions right now": "No open positions right now",
  "Check back later or follow us to be notified of new openings.": "Check back later or follow us to be notified of new openings.",
  "Position": "Position",
  "Department": "Department",
  "Open": "Open",
  "Closed": "Closed",
  "Apply Now": "Apply Now",
  "Position not found": "Position not found",
  "This role may have been filled or removed.": "This role may have been filled or removed.",
  "View open roles": "View open roles",
  "All open roles": "All open roles",
  "Apply for this role": "Apply for this role",
  "No description provided.": "No description provided.",
  "Fill out the form below and we'll get back to you within a few days.": "Fill out the form below and we'll get back to you within a few days.",
  "Application submitted": "Application submitted",
  "Thanks for applying - we'll review your application and reach out soon.": "Thanks for applying - we'll review your application and reach out soon.",
  "Current location": "Current location",
  "Website / GitHub": "Website / GitHub",
  "Resume / CV link": "Resume / CV link",
  "What's something you've built that you're proud of?": "What's something you've built that you're proud of?",
  "Link to your resume (Drive, Notion, PDF...)": "Link to your resume (Drive, Notion, PDF...)",
  "Tell us about your best work, side projects, or anything that shows how you think.": "Tell us about your best work, side projects, or anything that shows how you think.",
  "Submitting...": "Submitting...",
  "Submit application": "Submit application",
  "Failed to submit application": "Failed to submit application",

  // ── Legal hub ──
  "Review our terms of service and other important legal documents.": "Review our terms of service and other important legal documents.",
  "Acceptable Use Policy": "Acceptable Use Policy",
  "Understand the rules governing the use of our platform.": "Understand the rules governing the use of our platform.",
  "Cookie Policy": "Cookie Policy",
  "Understand how cookies are used and what kind of data is collected.": "Understand how cookies are used and what kind of data is collected.",
  "Data Processing Addendum": "Data Processing Addendum",
  "Explore our Data Processing Addendum (DPA).": "Explore our Data Processing Addendum (DPA).",
  "Learn how we handle, store, and protect your personal information.": "Learn how we handle, store, and protect your personal information.",
  "See the full list of data subprocessors.": "See the full list of data subprocessors.",
  "All the info you need to know about using our product and services.": "All the info you need to know about using our product and services.",
  "Learn more": "Learn more",

  // ── Lookup showcase ──
  "Visual": "Visual",
  "Domain lookup": "Domain lookup",
  "Google lookup": "Google lookup",
  "Dark web lookup": "Dark web lookup",
  "Live result · 0 credits": "Live result · 0 credits",
  "500 free credits": "500 free credits",
  "Try live. Enter an": "Try live. Enter an",
  ". No sign up or credit card needed.": ". No sign up or credit card needed.",
  "email address": "email address",
  "phone number with country code": "phone number with country code",
  "domain": "domain",
  "search query": "search query",
  "company name or domain": "company name or domain",
  "email, domain, or keyword": "email, domain, or keyword",
  "Email to look up": "Email to look up",
  "Phone number to look up": "Phone number to look up",
  "Domain to look up": "Domain to look up",
  "Google search query": "Google search query",
  "Company to look up": "Company to look up",
  "IP address to look up": "IP address to look up",
  "Dark web search query": "Dark web search query",
  "Looking up": "Looking up",
  "Checking live sources in real time": "Checking live sources in real time",
  "Demo limit reached": "Demo limit reached",
  "You've used all free demo lookups for now. Create an account to keep going with 500 free credits.": "You've used all free demo lookups for now. Create an account to keep going with 500 free credits.",
  "Lookup failed. Please try again.": "Lookup failed. Please try again.",
  "Deliverable": "Deliverable",
  "2 breaches": "2 breaches",
  "Low risk": "Low risk",
  "SSL valid": "SSL valid",
  "Series E": "Series E",
  "1,500 employees": "1,500 employees",
  "Clean": "Clean",
  "Datacenter": "Datacenter",
  "Passwords exposed": "Passwords exposed",
  "Last seen 2023": "Last seen 2023",
  "Number": "Number",
  "Line type": "Line type",
  "Spam": "Spam",
  "HQ": "HQ",
  "Valuation": "Valuation",
  "Threat": "Threat",

  // ── Marketing site: contact, use-cases, nav, cookie banner (2026-08-12) ──
  "Made in Switzerland": "Made in Switzerland",
  "Copy prompt": "Copy prompt",
  "Use cases": "Use cases",
  "See all use cases": "See all use cases",
  "global support": "global support",
  "Technical support": "Technical support",
  "For faster help, send your request ID and endpoint.": "For faster help, send your request ID and endpoint.",
  "Follow along": "Follow along",
  "Product news as it ships": "Product news as it ships",
  "Company updates and hiring": "Company updates and hiring",
  "SDKs and open source": "SDKs and open source",
  "Community questions and answers": "Community questions and answers",
  "Scan with your phone camera": "Scan with your phone camera",
  "Open WhatsApp Web": "Open WhatsApp Web",
  "Live": "Live",
  "Beginning of the": "Beginning of the",
  "next billion": "next billion",
  "Search use cases, signals…": "Search use cases, signals…",
  "All industries": "All industries",
  "All functions": "All functions",
  "View all": "View all",
  "One call, structured answer": "One call, structured answer",
  "in practice": "in practice",
  "The problem": "The problem",
  "With Encrata": "With Encrata",
  "Load more": "Load more",
  "Accept all": "Accept all",
  "Accept mandatory cookies": "Accept mandatory cookies",
  "Cookie settings": "Cookie settings",
  "cookie policy": "cookie policy",
  "Because you’re visiting from the EU or UK, we ask before using optional cookies.": "Because you’re visiting from the EU or UK, we ask before using optional cookies.",
  "Read our": "Read our",
  "Or message us directly at": "Or message us directly at",
  "WhatsApp username is": "WhatsApp username is",
  "Manage cookie settings": "Manage cookie settings",
  "Try live. Enter an email address. No sign up or credit card needed.": "Try live. Enter an email address. No sign up or credit card needed.",
  "Free tools": "Free tools",
  "Governance": "Governance",
  "Roadmap": "Roadmap",
  "What we plan to build next": "What we plan to build next",
  "The Encrata roadmap": "The Encrata roadmap",
  "A clear view of what we're planning next. Phone, domain, IP, and company lookups are planned; priorities and timing may change as we build.": "A clear view of what we're planning next. Phone, domain, IP, and company lookups are planned; priorities and timing may change as we build.",
  "Planned lookups": "Planned lookups",
  "These are the next lookup areas on our public roadmap. We'll share more detail as each takes shape.": "These are the next lookup areas on our public roadmap. We'll share more detail as each takes shape.",
  "No release dates are promised. This roadmap reflects current direction, and priorities can change.": "No release dates are promised. This roadmap reflects current direction, and priorities can change.",
  "Planned": "Planned",
  "Bring phone-number research into Encrata alongside the email lookups already available.": "Bring phone-number research into Encrata alongside the email lookups already available.",
  "Add direct domain research to enrich investigations and understand the organizations behind addresses.": "Add direct domain research to enrich investigations and understand the organizations behind addresses.",
  "Add IP address context for security investigations and abuse review.": "Add IP address context for security investigations and abuse review.",
  "Look up company-level context directly, alongside person and email data.": "Look up company-level context directly, alongside person and email data.",
  "Have a priority you'd like us to consider?": "Have a priority you'd like us to consider?",
  "Tell us what you need": "Tell us what you need",
  "Lead enrichment": "Lead enrichment",
  "Block fake signups": "Block fake signups",
  "SOC alert triage": "SOC alert triage",
  "KYC checks": "KYC checks",
  "SDKs & open source": "SDKs & open source",
  "Browse every free tool": "Browse every free tool",
  "Security & compliance": "Security & compliance",
  "Enrich signups before sales": "Enrich signups before sales",
  "Stop bots and throwaway accounts": "Stop bots and throwaway accounts",
  "Enrich indicators for analysts": "Enrich indicators for analysts",
  "Verify onboarding signals": "Verify onboarding signals",
  "For humans": "For humans",
  "Authenticate as an agent": "Authenticate as an agent",
  "Site summary for AI": "Site summary for AI",
  "Agent integration guide": "Agent integration guide",
  "API overview": "API overview",
  "Response shapes": "Response shapes",
  "Pricing for machines": "Pricing for machines",
  "Site & API routes": "Site & API routes",
  "Stack & app flows": "Stack & app flows",
  "Colors, type & components": "Colors, type & components",
  "Voice & terminology": "Voice & terminology",
  "Data & secret handling": "Data & secret handling",
  "Verify your integration": "Verify your integration",
  "Build & release flow": "Build & release flow",
  "Status, logs & tracing": "Status, logs & tracing",
  "Send the address": "Send the address",
  "We ask the mail server": "We ask the mail server",
  "Act on the verdict": "Act on the verdict",
  "We resolve the person": "We resolve the person",
  "Use the profile": "Use the profile",
  "We check known breaches": "We check known breaches",
  "Respond to exposure": "Respond to exposure",
  "Hash locally": "Hash locally",
  "We match anonymously": "We match anonymously",
  "Reject or accept": "Reject or accept",
  "Call the validity endpoint when an email address enters your system through a form, import, or checkout.": "Call the validity endpoint when an email address enters your system through a form, import, or checkout.",
  "Encrata checks syntax, domain and mailbox directly with the receiving server, and flags disposable and typo domains.": "Encrata checks syntax, domain and mailbox directly with the receiving server, and flags disposable and typo domains.",
  "Accept, reject or suggest a correction based on a clear valid / invalid / catch-all / risky verdict. One credit per check.": "Accept, reject or suggest a correction based on a clear valid / invalid / catch-all / risky verdict. One credit per check.",
  "Call the identity endpoint with just an email address, no name, no company, nothing else required.": "Call the identity endpoint with just an email address, no name, no company, nothing else required.",
  "Encrata matches the address against public profiles and returns name, role, company, location and social accounts.": "Encrata matches the address against public profiles and returns name, role, company, location and social accounts.",
  "Route, personalise, verify or investigate with a full picture of who is behind the address. Fields you ask for are the fields you get.": "Route, personalise, verify or investigate with a full picture of who is behind the address. Fields you ask for are the fields you get.",
  "Call the breach endpoint with an email address, one-off for a signup check, or on a schedule for monitoring.": "Call the breach endpoint with an email address, one-off for a signup check, or on a schedule for monitoring.",
  "Encrata searches disclosed breach data and returns every breach the address appears in, when it happened, and what leaked.": "Encrata searches disclosed breach data and returns every breach the address appears in, when it happened, and what leaked.",
  "Alert the user, raise a risk score, force a reset or require MFA. The full breach history is one credit away.": "Alert the user, raise a risk score, force a reset or require MFA. The full breach history is one credit away.",
  "Your client hashes the password and sends only the first characters of the hash. The password itself never leaves the device.": "Your client hashes the password and sends only the first characters of the hash. The password itself never leaves the device.",
  "Encrata checks the prefix against the breach corpus via k-anonymity and returns whether the password was found and how many times.": "Encrata checks the prefix against the breach corpus via k-anonymity and returns whether the password was found and how many times.",
  "Block passwords that appear in breach dumps at registration, reset or login. One credit per check.": "Block passwords that appear in breach dumps at registration, reset or login. One credit per check.",
  "Answers come from the mail server itself, not a guess from patterns": "Answers come from the mail server itself, not a guess from patterns",
  "Disposable and throwaway domains are flagged before they cost you anything": "Disposable and throwaway domains are flagged before they cost you anything",
  "1 credit per check, cheap enough to run on every address you touch": "1 credit per check, cheap enough to run on every address you touch",
  "Cached results are free, so repeated checks never double-charge": "Cached results are free, so repeated checks never double-charge",
  "No match, no charge: a lookup that finds nothing costs nothing": "No match, no charge: a lookup that finds nothing costs nothing",
  "Every field is labelled found or not found, so you never guess what to trust": "Every field is labelled found or not found, so you never guess what to trust",
  "Ask only for the fields you need with the fields parameter": "Ask only for the fields you need with the fields parameter",
  "One API call replaces minutes of manual research per contact": "One API call replaces minutes of manual research per contact",
  "Full breach history, names, dates and exposed data classes per breach": "Full breach history, names, dates and exposed data classes per breach",
  "1 credit per check, so continuous monitoring stays affordable": "1 credit per check, so continuous monitoring stays affordable",
  "New-breach detection turns a public leak into a same-day security response": "New-breach detection turns a public leak into a same-day security response",
  "Works for one address or your whole domain": "Works for one address or your whole domain",
  "k-anonymity: the password never leaves the user's device": "k-anonymity: the password never leaves the user's device",
  "Blocks the exact credentials attackers use in stuffing lists": "Blocks the exact credentials attackers use in stuffing lists",
  "1 credit per check, screen every registration and reset": "1 credit per check, screen every registration and reset",
  "A single API call satisfies auditors asking for compromised-password controls": "A single API call satisfies auditors asking for compromised-password controls",
};

export default en;
